import { calculateInstallmentValue } from '@zion/shared/calculator';

const codeUniverseOriginalValue = 5708;
const codeUniverseInstallmentPrice = 97.94;
const codeUniverseTotalPrice = codeUniverseInstallmentPrice * 12;

const testesAutomatizadosComAngularSubscriptionInstallmentPrice = 57.81;
const testesAutomatizadosComAngularSubscriptionTotalPrice =
  testesAutomatizadosComAngularSubscriptionInstallmentPrice * 12;

const testesAutomatizadosComAngularLifetimeInstallmentPrice = 77.26;
const testesAutomatizadosComAngularLifetimeTotalPrice =
  testesAutomatizadosComAngularLifetimeInstallmentPrice * 12;

const angularModernoSubscriptionInstallmentPrice = 39.2;
const angularModernoSubscriptionTotalPrice =
  angularModernoSubscriptionInstallmentPrice * 12;

const angularModernoLifetimeInstallmentPrice = 59.88;
const angularModernoLifetimeTotalPrice =
  angularModernoLifetimeInstallmentPrice * 12;

const formulariosComAngularSubscriptionInstallmentPrice = 39.2;
const formulariosComAngularSubscriptionTotalPrice =
  formulariosComAngularSubscriptionInstallmentPrice * 12;

const formulariosComAngularLifetimeInstallmentPrice = 59.88;
const formulariosComAngularLifetimeTotalPrice =
  formulariosComAngularLifetimeInstallmentPrice * 12;

export const prices = {
  codeUniverse: {
    originalValue: codeUniverseOriginalValue,
    inFull: 947,
    installmentValue: codeUniverseInstallmentPrice,
    totalValue: codeUniverseTotalPrice,
    discount: calcDiscountPercent(
      codeUniverseOriginalValue,
      codeUniverseTotalPrice,
    ),
    promotionInstallmentValue: 87,
    promotionTotalValue: 12 * 87,
    promotionDiscount: calcDiscountPercent(117, 87),
  },
  testesAutomatizadosComAngular: {
    subscription: {
      inFull: 559,
      installmentValue:
        testesAutomatizadosComAngularSubscriptionInstallmentPrice,
      totalValue: testesAutomatizadosComAngularSubscriptionTotalPrice,
      promotionInstallmentValue: 55,
      promotionTotalValue: 12 * 55,
      promotionDiscount: calcDiscountPercent(79, 55.3),
    },
    lifetime: {
      inFull: 747,
      installmentValue: testesAutomatizadosComAngularLifetimeInstallmentPrice,
      totalValue: testesAutomatizadosComAngularLifetimeTotalPrice,
      promotionInstallmentValue: 69,
      promotionTotalValue: 12 * 69,
      promotionDiscount: calcDiscountPercent(99, 69.3),
    },
  },
  angularModerno: {
    subscription: {
      inFull: 379,
      installmentValue: angularModernoSubscriptionInstallmentPrice,
      totalValue: angularModernoSubscriptionTotalPrice,
      promotionInstallmentValue: 27.94,
      promotionTotalValue: 12 * 27.94,
      promotionDiscount: calcDiscountPercent(39.92, 27.94),
    },
    lifetime: {
      inFull: 579,
      installmentValue: angularModernoLifetimeInstallmentPrice,
      totalValue: angularModernoLifetimeTotalPrice,
      promotionInstallmentValue: 39.55,
      promotionTotalValue: 39.55 * 12,
      promotionDiscount: calcDiscountPercent(
        angularModernoLifetimeInstallmentPrice,
        39.55,
      ),
    },
  },
  introducaoAoAngular: {
    totalValue: 97,
    promotionTotalValue: 67,
    promotionDiscount: calcDiscountPercent(97, 67),
  },
  formulariosComAngular: {
    subscription: {
      inFull: 379,
      installmentValue: formulariosComAngularSubscriptionInstallmentPrice,
      totalValue: formulariosComAngularSubscriptionTotalPrice,
      promotionTotalValue: calcValueWithDiscount(
        formulariosComAngularSubscriptionTotalPrice,
        50,
      ),
      promotionDiscount: calcDiscountPercent(
        formulariosComAngularSubscriptionInstallmentPrice,
        calcValueWithDiscount(
          formulariosComAngularSubscriptionInstallmentPrice,
          50,
        ),
      ),
      promotionInstallmentValue: calcValueWithDiscount(
        formulariosComAngularSubscriptionInstallmentPrice,
        50,
      ),
      promotionInFull: 189,
    },
    forever: {
      inFull: 382,
      installmentValue: formulariosComAngularLifetimeInstallmentPrice,
      totalValue: formulariosComAngularLifetimeTotalPrice,
      promotionTotalValue: calcValueWithDiscount(
        formulariosComAngularLifetimeTotalPrice,
        34,
      ),
      promotionDiscount: calcDiscountPercent(
        formulariosComAngularLifetimeInstallmentPrice,
        calcValueWithDiscount(
          formulariosComAngularLifetimeInstallmentPrice,
          34,
        ),
      ),
      promotionInstallmentValue: calcValueWithDiscount(
        formulariosComAngularLifetimeInstallmentPrice,
        34,
      ),
    },
  },
  dominandoAgentesDeIa: {
    subscription: {
      inFull: 187,
      installmentValue: 19.34,
      totalValue: 19.34 * 12,
    },
    forever: {
      inFull: 289,
      installmentValue: 29,
      totalValue: 29 * 12,
    },
  },
  signalForms: {
    subscription: {
      installmentValue: 29.89,
      totalValue: 29.89 * 12,
      inFull: 289,
    },
    forever: {
      inFull: 479,
      installmentValue: 49.54,
      totalValue: 49.54 * 12,
    },
  },
  ssrSsgComAngular: {
    subscription: {
      inFull: 379,
      installmentValue: 39.2,
      totalValue: 39.2 * 12,
    },
  },
  specDriven: {
    subscription: {
      inFull: 289,
      installmentValue: 29.89,
      totalValue: 29.89 * 12,
    },
  },
  contextEngineering: {
    subscription: {
      inFull: 289,
      installmentValue: 29.89,
      totalValue: 29.89 * 12,
    },
  },
  multiAgentic: {
    subscription: {
      inFull: 189,
      installmentValue: 19.55,
      totalValue: 19.55 * 12,
    },
  },
  nxMonorepoComIA: {
    subscription: {
      inFull: 379,
      installmentValue: 39.2,
      totalValue: 39.2 * 12,
    },
  },
  websiteComStitchEAntigravity: {
    subscription: {
      inFull: 189,
      installmentValue: 19.55,
      totalValue: 19.55 * 12,
    },
  },
  nxBasico: {
    subscription: {
      inFull: 119,
      installmentValue: 17.3,
      totalValue: 17.3 * 8,
    },
  },
  mentoriaMensalEmGrupo: {
    originalValue: 3000,
    currentValue: 0,
  },
};

export function calcDiscountPercent(from: number, to: number) {
  return 100 - (to / from) * 100;
}

export function calcValueWithDiscount(value: number, discount: number) {
  return value * (1 - discount / 100);
}

export function calcHotmartInstallment(
  value: number,
  installmentsCount = 12,
): number {
  const interestRate = 0.0349;
  return calculateInstallmentValue(value, interestRate, installmentsCount);
}
